export const resourcePaginate = async (resources, count, method, arg, page) => {
    if (resources.length < count) {
        let disableScroll = new Event('disableWindowScroll');
        window.dispatchEvent(disableScroll);
        await method(page, arg);
        let enableScroll = new Event('enableWindowScroll');
        window.dispatchEvent(enableScroll);
    }
};